export default {
  index: [
    {
      path: '/eszcnanghtype',
      component: resolve => require(['./eszcnanghtypeIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/eszcnanghtype/_router.js